<template>
    <div class="timeline-container">
        <UIGridContainer>
            <UIGridRow class="justify-content-center">
                <UIGridCol md="10">
                    <div class="text-md-center content">
                        <h2>{{ translate('timeline.title') }}</h2>
                        <p class="mb-0 mb-md-2">{{ translate('timeline.content1') }}</p>
                        <br />
                        <p>{{ translate('timeline.content2') }}</p>
                    </div>
                </UIGridCol>
            </UIGridRow>
            <UIGridRow class="flex-column justify-content-center align-items-center">
                <UIGridCol md="8">
                    <section class="timeline">
                        <ul>
                            <AboutTimelineElement>
                                <div>
                                    <p v-html="translate('timeline.element1.title')"></p>
                                    <p>{{ translate('timeline.element1.content') }}</p>
                                </div>
                            </AboutTimelineElement>
                            <AboutTimelineElement>
                                <div>
                                    <p class="font-weight-bold">{{ translate('timeline.element2.title') }}</p>
                                    <p>{{ translate('timeline.element2.content') }}</p>
                                </div>
                            </AboutTimelineElement>
                            <AboutTimelineElement>
                                <div>
                                    <p class="font-weight-bold">{{ translate('timeline.element3.title') }}</p>
                                    <p>{{ translate('timeline.element3.content') }}</p>
                                </div>
                            </AboutTimelineElement>
                            <AboutTimelineElement>
                                <div>
                                    <p class="font-weight-bold">{{ translate('timeline.element4.title') }}</p>
                                    <p v-html="translate('timeline.element4.content')"></p>
                                </div>
                            </AboutTimelineElement>
                            <AboutTimelineElement>
                                <div>
                                    <p class="font-weight-bold">{{ translate('timeline.element5.title') }}</p>
                                    <p v-html="translate('timeline.element5.content')"></p>
                                </div>
                            </AboutTimelineElement>
                            <AboutTimelineElement>
                                <div>
                                    <p class="font-weight-bold">{{ translate('timeline.element6.title') }}</p>
                                    <p v-html="translate('timeline.element6.content')"></p>
                                </div>
                            </AboutTimelineElement>
                            <AboutTimelineElement>
                                <div>
                                    <p class="font-weight-bold">{{ translate('timeline.element7.title') }}</p>
                                    <p v-html="translate('timeline.element7.content')"></p>
                                </div>
                            </AboutTimelineElement>
                        </ul>
                    </section>
                </UIGridCol>
            </UIGridRow>
        </UIGridContainer>
    </div>
</template>

<script>
import { UIGridContainer, UIGridRow, UIGridCol } from '@dundle/ui/components';
import { AboutTimelineElement } from '~/components/about';
import TranslationMixin from '~/mixins/TranslationMixin';
export default {
    components: {
        UIGridRow,
        UIGridCol,
        AboutTimelineElement,
        UIGridContainer,
    },
    mixins: [TranslationMixin],
};
</script>

<style lang="scss" scoped>
.timeline-container {
    background-color: $color-primary-dark;
}

.content {
    color: $color-text-inverted;

    h2 {
        color: $color-text-inverted;
    }

    margin-top: 4rem;
    @media screen and (min-width: 768px) {
        margin-top: 6rem;
    }
}

/* TIMELINE
–––––––––––––––––––––––––––––––––––––––––––––––––– */

.timeline ul {
    color: $color-text-inverted;
    padding: 2rem 0 0 0;
    margin-bottom: 0;
    margin-left: -8px;

    @media screen and (min-width: 768px) {
        margin-left: auto;
    }

    li:last-child {
        padding-bottom: 1rem;

        @media screen and (min-width: 768px) {
            padding-bottom: 7rem;
        }
    }

    p:first-child {
        color: $color-text-inverted;
        margin-bottom: 0.5rem;
    }

    b {
        color: $color-text-inverted;
    }
}

p {
    line-height: 1.467rem;
}
</style>

<i18n></i18n>
